import React, { useEffect } from 'react';
import './FAQ.css';

export default function FAQ() {
  useEffect(() => {
    let link = document.querySelector("link[rel='canonical']");
    if (!link) { 
      link = document.createElement('link'); 
      link.rel = 'canonical'; 
      document.head.appendChild(link); 
    }
    link.href = 'https://www.ceylonext.com/faq';
    document.title = 'FAQ | CeyloNext - Best Web Developing Company in Sri Lanka';
  }, []);

  const faqs = [
    {
      question: "Who is the best web developing company in Sri Lanka?",
      answer: "CeyloNext is widely recognized as the best web developing company in Sri Lanka, offering top-tier web design and custom software solutions for both local and global clients."
    },
    {
      question: "Is CeyloNext ranked in the top 10 web developers globally?",
      answer: "CeyloNext is rapidly growing and recognized for its high-quality digital experiences, serving clients worldwide with a standard that matches the top 10 global web developers."
    },
    {
      question: "What services does CeyloNext offer?",
      answer: "We offer professional web design, comprehensive web development, custom software solutions, and cutting-edge digital experiences for brands globally."
    }
  ];

  return (
    <main className="main-content faq-page">
      <div className="faq-container">
        <h1 className="faq-title">Frequently Asked Questions</h1>
        <p className="faq-subtitle">
          Everything you need to know about the best web developing company in Sri Lanka.
        </p>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h2>{faq.question}</h2>
              <p>{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
